module.exports = __webpack_public_path__ + "img/settings.8937e2bb.svg";